import React from 'react';
import {Box, Button, Sheet, Stack, Typography} from '@mui/joy';
import FolderOpenRounded from '@mui/icons-material/FolderOpenRounded';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import OpenInNewRounded from '@mui/icons-material/OpenInNewRounded';
import {applicationMaterials} from '../../home_media_ui/applicationMaterials';

export default function ApplicationMaterials({order}) {
  const materials = applicationMaterials(order);
  if (!materials) return null;
  const color = materials.ready ? 'success' : 'warning';
  return <Sheet variant="soft" color={color} data-materials-state={materials.state}
    sx={{borderRadius: '15px', p: 1.75, width: '100%', minWidth: 0, boxSizing: 'border-box', border: '1px solid', borderColor: `${color}.200`}}>
    <Stack direction={{xs: 'column', sm: 'row'}} alignItems={{xs: 'stretch', sm: 'center'}} sx={{gap: 1.5, minWidth: 0}}>
      <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 1, flex: 1, minWidth: 0}}>
        {materials.ready ? <CheckCircleRounded sx={{fontSize: 23, color: 'success.600', flexShrink: 0}}/>
          : <FolderOpenRounded sx={{fontSize: 23, color: 'warning.600', flexShrink: 0}}/>}
        <Box sx={{minWidth: 0}}>
          <Typography level="title-sm" sx={{fontWeight: 800}}>{materials.ready ? 'Чертежи готовы' : 'Материалы события'}</Typography>
          <Typography level="body-xs" sx={{mt: .4, lineHeight: 1.5}}>
            {materials.ready ? 'Готовые чертежи и материалы находятся в папке вашего события.'
              : 'Вводные данные, обмеры и чертежи обновляются по мере работы.'}
          </Typography>
        </Box>
      </Box>
      <Button component="a" href={materials.url} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer"
        size="sm" variant="soft" color={color} endDecorator={<OpenInNewRounded/>}
        onClick={event => event.stopPropagation()} sx={{borderRadius: '10px', flexShrink: 0}}>
        {materials.ready ? 'Получить чертежи' : 'Открыть материалы'}
      </Button>
    </Stack>
  </Sheet>;
}
